module.exports = __webpack_public_path__ + "static/img/tab-service-center-v2.9d5e0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tab-service-center-v2.png
// module id = hcuu
// module chunks = 0